import { getTimezone } from "../../../../assets/js/src/general/utils";

const LOCALE_WHITELIST = ["en-GB", "en-US"];
const userLocale = new Intl.NumberFormat().resolvedOptions().locale;
export const LOCALE = LOCALE_WHITELIST.includes(userLocale)
  ? userLocale
  : "en-GB";

export const formatDate = (timestamp, options = {}) =>
  new Date(timestamp * 1000).toLocaleDateString(LOCALE, {
    weekday: "short",
    day: "numeric",
    month: "long",
    timeZone: options.timeZone || getTimezone(),
    ...options,
  });

export const formatActivityDate = (timestamp) =>
  formatDate(timestamp, { month: "short", year: "numeric" });

export const formatActivityTime = (timestamp) =>
  new Date(timestamp * 1000).toLocaleTimeString(LOCALE, {
    hour: "2-digit",
    minute: "2-digit",
  });

export const extractGetSearchesEmails = (data) => {
  const ret = new Set();

  const candidateId = Object.keys(data?.results || {})[0];
  if (!candidateId || !data.results[candidateId]) return ret;

  Object.values(data.results[candidateId]).forEach((result) => {
    ["personalEmails", "workEmails"].forEach((key) => {
      result.emails[key].forEach((emailObj) => {
        ret.add(emailObj.email);
      });
    });
  });
  return ret;
};
